/**
 * @author bly & lifei & gll
 * 功能：供应商管理
 */

import { Service } from '@/tools'

export class CustomerService<T extends TCustomer.Customer> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCustomer.Customer}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //分批查询所有客户
  // /api/customer/customer/v1/allCustomers
  allCustomers = <K extends T['ApiAllCustomers']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAllCustomers', data)

  // 客户列表
  // /api/customer/customer/v1/customerPage
  customerPage = <K extends T['ApiCustomerPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomerPage', data)

  // 添加客户
  // /api/customer/customer/v1/addCustomer
  addCustomer = <K extends T['ApiAddCustomer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCustomer', data)

  // 编辑客户
  // /api/customer/customer/v1/updateCustomer
  updateCustomer = <K extends T['ApiUpdateCustomer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCustomer', data)

  // 查看客户
  // /api/customer/customer/v1/customerDetail
  customerDetail = <K extends T['ApiCustomerDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomerDetail', data)

  // 客户冻结、解冻
  // /api/customer/customer/v1/frozen
  frozen = <K extends T['ApiFrozen']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFrozen', data)

  // NC编码
  // /api/customer/customer/v1/listNcInfo
  listNcInfo = <K extends T['ApiListNcInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiListNcInfo', data)

  //校验重复的客户
  // /api/customer/customer/v1/checkSameCustomer
  checkSameCustomer = <K extends T['ApiCheckSameCustomer']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckSameCustomer', data)

  //校验重复社会信用代码
  // /api/customer/customer/v1/checkSameCreditCode
  checkSameCreditCode = <K extends T['ApiCheckSameCreditCode']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckSameCreditCode', data)

  //查询公司、小连锁组织
  // /api/customer/customer/v1/getOrgCompanyList
  getOrgCompanyList = <K extends T['ApiGetOrgCompanyList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetOrgCompanyList', data)

  //客户 清盘/撤销清盘
  // /api/customer/customer/v1/liquidation
  liquidation = <K extends T['ApiLiquidation']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiLiquidation', data, '操作成功')

  //客户 清盘/撤销清盘页面回显
  // /api/customer/customer/v1/customerBaseInfo
  customerBaseInfo = <K extends T['ApiCustomerBaseInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomerBaseInfo', data)

  //客户 清盘执行
  // /api/customer/customer/v1/liquidationExecute
  liquidationExecute = <K extends T['ApiLiquidationExecute']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiLiquidationExecute', data, '操作成功')

  // liquidateExecutePage
  //客户 清盘执行页面回显
  // /api/customer/customer/v1/liquidationExecuteInfo
  liquidationExecuteInfo = <K extends T['ApiLiquidationExecuteInfo']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiLiquidationExecuteInfo', data)

  // 客户编码去重提醒：/api/customer/customer/v1/checkCustomerCode
  checkCustomerCode = <K extends T['ApiCheckCustomerCode']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckCustomerCode', data)

  // 通过片区查询客户：/api/customer/customer/v1/getCustomerListByAreaCode
  getCustomerListByAreaCode = <K extends T['ApiGetCustomerListByAreaCode']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetCustomerListByAreaCode', data)

  // 通过片区查询客户：/api/customer/customer/v1/getCustomerPageListByAreaCode
  getCustomerPageListByAreaCode = <K extends T['ApiGetCustomerPageListByAreaCode']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetCustomerPageListByAreaCode', data)
  // 通过片区查询客户：/api/customer/customer/v1/getCustomerPageListByAreaCode
  customerSynchronizeWms = <K extends T['ApiCustomerSynchronizeWms']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCustomerSynchronizeWms', data)
  //查询客户关联的默认结算信息 /api/customer/customer/v1/getCustomerNcInfo
  getCustomerNcInfo = <K extends T['ApiGetCustomerNcInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetCustomerNcInfo', data)
  //查询审核状态
  checkUnderApproval = <K extends T['ApiCheckUnderApproval']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCheckUnderApproval', data)
}
